import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchLeadFeedbackList = createAsyncThunk(
    "fetchLeadFeedbackList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/lead/remark-lead-feedback-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const LeadFeedbackSlice = createSlice({
    name: "LeadFeedbackSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchLeadFeedbackList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchLeadFeedbackList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchLeadFeedbackList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default LeadFeedbackSlice.reducer;
